import { render, staticRenderFns } from "./session-list.vue?vue&type=template&id=0e37bddb&scoped=true&"
import script from "./session-list.vue?vue&type=script&lang=ts&"
export * from "./session-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37bddb",
  null
  
)

export default component.exports